import React from 'react';
import { useSpring, animated } from 'react-spring';
import { TiInfo } from 'react-icons/ti';
import { connect } from 'react-redux';

import { removeIgnoredUrls } from 'redux/urls/url.action';
import Button from 'common-components/Button';

import './confirmIgnore.style.css'


const ConfirmIgnore = ({
  priviledge,
  unPublishedUrls,
  removeIgnoredUrls,
  showModal,
  setShowModal,
}) => {

  const animation = useSpring({
    config: {
      duration: 250
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`
  });

  const clearIgnored = () => {
    removeIgnoredUrls(unPublishedUrls);
    setShowModal(false);
  }

  return (
    <>
      {showModal ? (
        <div className='alert-background'>
          <animated.div style={animation}>
            <div className='alert-wrapper'>
              <div className='alert-content'>
                <TiInfo className='icon info' />
                <h1 className='header info'>Clear Ignored</h1>
                <div className='line1'>You can still review ignored URLs.</div>
                <div className='line2'> Confirming this will clear ignored URLs from table!</div>
                <div className='ignore-menu'>
                  <div className='confirm'>
                    <Button
                      children='Confirm'
                      onClick={() => clearIgnored()}
                      disabled={!(priviledge.is_admin || priviledge.is_reviewer)} />
                  </div>
                  <div className='cancel'>
                    <Button
                      children='Cancel'
                      onClick={() => setShowModal(false)} />
                  </div>
                </div>
              </div>
            </div>
          </animated.div>
        </div>
      ) : null}
    </>
  );
};

const mapStateToProps = ({
  authentication: { priviledge },
  URLs: { unPublishedUrls } }) => ({
    priviledge,
    unPublishedUrls
  });

const mapDispatchToProps = dispatch => ({
  removeIgnoredUrls: urls => dispatch(removeIgnoredUrls(urls))
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmIgnore);